module.exports = __webpack_public_path__ + "img/contact-page-left.53625877.svg";